var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DialogContent as MuiDialogContent } from '@mui/material';
import classNames from 'classnames';
import styles from './DialogContent.module.scss';
export function DialogContent(_a) {
    var { className } = _a, restProps = __rest(_a, ["className"]);
    return (_jsx(MuiDialogContent, Object.assign({}, restProps, { className: classNames(className, styles['con-dialog-content']) })));
}
